import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { RelationshipType } from '@sierralabs/entity-core';
const RelationshipTypePicker = props => {
    const { disabled, value = RelationshipType.ManyToOne, helperText, onChange } = props;
    return (React.createElement(TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', placeholder: 'Relationship Type', value: value, disabled: disabled, helperText: helperText, onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value) },
        React.createElement(MenuItem, { value: 'one-to-many' }, "One-to-Many"),
        React.createElement(MenuItem, { value: 'many-to-one' }, "Many-to-One"),
        React.createElement(MenuItem, { value: 'many-to-many' }, "Many-to-Many"),
        React.createElement(MenuItem, { value: 'one-to-one', disabled: true }, "One-to-One")));
};
export default RelationshipTypePicker;
//# sourceMappingURL=RelationshipTypePicker.js.map